import styled from 'styled-components';
import { getSizeInRem } from '../../methods/common.js';
import '../../constants/colors.js';
import '../../constants/fonts.js';
import '../../constants/theme.js';
import '../../constants/files.js';
import '../../constants/color-variant.js';
import '../../constants/zIndexList.js';
import '../../mixins/style-mixins.js';
import '../../mixins/scrollbar.js';
import { clickableCursorStyle } from '../../mixins/cursor.js';
import { getCommonFontStyleMixin } from '../../mixins/font.js';

const BorderRadius = getSizeInRem(12);
const DropdownWrapper = styled.div `
    .dropdown-main {
        display: inline-block;
    }
    .dropdown__control {
        ${clickableCursorStyle};
        direction: ltr;
    }

    .dropdown__menu {
        display: inline-block;
        width: auto;

        .dropdown__menu-list {
            padding: ${BorderRadius};
            .dropdown__option {
                ${clickableCursorStyle}
                background-color: white;
                display: inline-flex;
                padding: ${getSizeInRem(14)} ${getSizeInRem(18)};
                border: 1px solid #e3e3e3;
                display: inline-flex;
                align-items: center;
                justify-content: flex-start;
                gap: 10px;
                min-width: max-content;

                ${getCommonFontStyleMixin({
    weight: "medium",
})}
                &:first-of-type {
                    border-radius: ${BorderRadius} ${BorderRadius} 0 0;
                }
                &:last-of-type {
                    border-radius: 0 0 ${BorderRadius} ${BorderRadius};
                }
            }
        }
    }
`;

export { DropdownWrapper };
//# sourceMappingURL=Dropdown.styles.js.map
